import { pipeline, type FeatureExtractionPipeline } from '@huggingface/transformers';

// Runs fully client-side (WASM) — no symptom or query text ever leaves the browser.
// Model weights are fetched from the Hugging Face CDN on first use and cached by
// the browser afterward.
const MODEL_ID = 'Xenova/all-MiniLM-L6-v2';

let extractorPromise: Promise<FeatureExtractionPipeline> | null = null;

function getExtractor(): Promise<FeatureExtractionPipeline> {
  if (!extractorPromise) {
    extractorPromise = pipeline('feature-extraction', MODEL_ID);
  }
  return extractorPromise;
}

export async function embedText(text: string): Promise<number[]> {
  const extractor = await getExtractor();
  const output = await extractor(text, { pooling: 'mean', normalize: true });
  return Array.from(output.data as Float32Array);
}

export function cosineSimilarity(a: number[], b: number[]): number {
  let dot = 0;
  for (let i = 0; i < a.length; i++) {
    dot += a[i] * b[i];
  }
  // Embeddings above are already L2-normalized, so dot product == cosine similarity.
  return dot;
}
